<template>
  <div>
    <page-title title="Autenticação de 2 Fatores"/>
    <div class="l-row">
      <div class="l-col-4@md" v-if="modulesPresets.length" v-for="modulePreset in modulesPresets" :key="modulePreset">
        <preset-card :module="modulePreset"/>
      </div>
    </div>
    <panel>
      <a class="btn btn-primary" target="_blank" :href="urlLogarme">{{ linkTitle }}</a>
    </panel>
  </div>
</template>

<script>
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'
  import api from '@/api'

  export default {
    data: () => ({
      urlLogarme: '',
      currentUser: null,
      linkTitle: ''
    }),
    async mounted () {
      this.urlLogarme = `https://app.v1.logar.me/toggleTwoFactor?vendor_id=e7411b44-25ea-11e8-b467-0ed5f89f718b&redirect_url=` + window.location.href

      this.currentUser = await api.getUser()

      if (this.currentUser.twoFactorEnabled) {
        this.linkTitle = 'Desativar Autenticação de 2 Fatores'
      } else {
        this.linkTitle = 'Ativar Autenticação de 2 Fatores'
      }
    },
    watch: {
    },
    components: {
      PageTitle,
      Panel
    }
  }
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// Config.vue?d34b84f2